import { InputFieldProps } from "../../types/InputProps";
import { Typography } from "../Typography";
import { Grid } from "../Grid";
import { MinimizeOutlined } from "@mui/icons-material";
import FormDatePicker from "./FormDatePicker";
import dayjs from "dayjs";
import React from "react";
import { useMediaQuery } from "../../hooks";
import { useTheme } from "@mui/material";

export const initFormFieldsForObjectValues = (
  name: string,
  fields: InputFieldProps[] | undefined,
) => {
  if (!fields) return [];
  return fields.map((f) => {
    return { ...f, ...{ name: `${name}.${f.name}` } };
  });
};

const FormDateRangePicker = (props: InputFieldProps) => {
  const { name, label, meta, control } = props;

  const {
    start = {
      key: "start",
      label: "Start",
    },
    end = { key: "end", label: "End" },
  } = meta;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [minDate, setMinDate] = React.useState<any>(dayjs());
  const onStarDateChange = (d: any) => setMinDate(d);
  start.onChange = onStarDateChange;
  end.onChange = () => false;
  return (
    <>
      <Typography>{label}</Typography>
      <Grid
        size={12}
        flexDirection={isMobile ? "column" : "row"}
        display={"flex"}
        justifyContent={"space-between"}
      >
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormDatePicker
            label={start.label}
            name={name + "." + start.key}
            control={control}
            type="datepicker"
            value={dayjs()}
            meta={start}
          />
        </Grid>
        {!isMobile && (
          <Grid
            size={0.7}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"60px"}
          >
            <MinimizeOutlined />
          </Grid>
        )}
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormDatePicker
            label={end.label}
            name={name + "." + end.key}
            control={control}
            type="datepicker"
            value={dayjs()}
            meta={{
              ...end,
              ...{
                minDate,
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormDateRangePicker;
